export default "__VITE_ASSET__Cvy$tpFf__"